import { render, staticRenderFns } from "./SortSolid.vue?vue&type=template&id=95372540&scoped=true"
var script = {}
import style0 from "./SortSolid.vue?vue&type=style&index=0&id=95372540&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95372540",
  null
  
)

export default component.exports